/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExternalFileDto } from '../../models/external-file-dto';
import { ExternalFileProvider } from '../../models/external-file-provider';

export interface ExternalFilesUploadPost$Json$Params {
      body?: {
'DataSourceId'?: string;
'Provider'?: ExternalFileProvider;
'ProviderFileId'?: string;
'FileName'?: string;
'MimeType'?: string;
'Path'?: string;
}
}

export function externalFilesUploadPost$Json(http: HttpClient, rootUrl: string, params?: ExternalFilesUploadPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExternalFileDto>> {
  const rb = new RequestBuilder(rootUrl, externalFilesUploadPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExternalFileDto>;
    })
  );
}

externalFilesUploadPost$Json.PATH = '/external-files/upload';
